import * as getters from '@/store/modules/bankassurance/subscribe/getters'
import * as mutations from '@/store/modules/bankassurance/subscribe/mutations'
import * as actions from '@/store/modules/bankassurance/subscribe/actions'

const state = {
    accountsBalances: [],
    holder: {},
    travelProtectionPlan: [],
    travelCapitalSscale: [],
    gender: [],
    province: [],
    city: [],
    addressCountry: [],
    country: [],
    quotation: {},
    aUTBrand: [],
    aUTModel: [],
    aUTCapitalCRBAI: [],
    civilStatus: [],
    documents: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
